import { ServiceCategoriesContentResponseModel } from '@/services/platform/api/model';
import { useApp } from '@/lib/core/providers/appProvider';
import { CategoryCard } from './card';

// ── CategoryGrid ──────────────────────────────────────────────────────────────

export interface CategoryGridProps {
  items: ServiceCategoriesContentResponseModel[];
  activeSlug: string | null;
  loadingFlows: Record<string, boolean>;
  onItemClick: (slug: string, categoryId?: string) => void;
}

export function CategoryGrid({ items, activeSlug, loadingFlows, onItemClick }: CategoryGridProps) {
  const { user } = useApp();
  const hasActiveMembership = user?.hasActiveMembership ?? false;

  if (!items.length) return null;

  return (
    <div className="grid grid-cols-2 gap-2">
      {items.map((item, i) => {
        const categoryProps = item.properties;
        const name = item.name ?? String(i);
        const slug = categoryProps?.slug ?? item.route?.path ?? String(i);

        if (categoryProps?.membersOnly && !hasActiveMembership) return null;

        return (
          <CategoryCard
            key={slug + i}
            name={name}
            icon={categoryProps?.icon}
            isActive={activeSlug === slug}
            isLoading={item.id ? loadingFlows[item.id] : false}
            onClick={() => onItemClick(slug, item.id)}
          />
        );
      })}
    </div>
  );
}
